import { useGameStore } from '@/store/gameStore';
import { blockImageMap } from '@/utils/blockAssets';

/**
 * スコア表示コンポーネント
 * PIXIキャンバス上にオーバーレイ表示する
 */
const ScoreDisplay = () => {
  const { score, highScore } = useGameStore();

  return (
    <div className="grid place-items-center">
      <p className="text-yellow-400 text-2xl font-bold">{score}</p>
      <p className="text-sm text-gray-200">{highScore}</p>
    </div>
  );
};

const NextDropDisplay = () => {
  const nextDropBlockId = useGameStore((s) => s.nextDropBlockId);
  const imageSrc =
    nextDropBlockId !== null ? blockImageMap[nextDropBlockId] : undefined;

  return (
    <div className="grid items-center gap-1 text-center border-2 border-white rounded-full p-4 size-48">
      {imageSrc ? (
        <img
          src={imageSrc}
          alt="next block"
          className="aspect-square object-contain"
        />
      ) : (
        <div className="bg-white rounded-full opacity-20" />
      )}
    </div>
  );
};

const imageModules = import.meta.glob('/assets/images/blocks/season2/*.png', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

const BlockEvolutionItem = ({
  image,
  index,
  blockCounts,
}: {
  image: string;
  index: number;
  blockCounts: Record<string, number>;
}) => {
  const blockCount =
    index <= 2 ? 1 : blockCounts[`block_${`${index - 1}`.padStart(2, '0')}`];
  if (index >= 10) {
    return;
  }
  return (
    <li key={image}>
      {blockCount > 0 ? (
        <img
          src={image}
          alt=""
          className="aspect-square object-contain size-48"
        />
      ) : (
        <div className="grid place-items-center bg-gray-600 rounded-full size-48 aspect-square object-contain border-4 border-yellow-500 opacity-50">
          <p className="text-white text-2xl font-bold">？</p>
        </div>
      )}
    </li>
  );
};

const BlockEvolution = () => {
  const { blockCounts } = useGameStore();
  return (
    <ul className="grid gap-12 place-items-center">
      {Object.values(imageModules).map((value, index) => (
        <BlockEvolutionItem
          key={value}
          image={value}
          index={index}
          blockCounts={blockCounts}
        />
      ))}
    </ul>
  );
};

export function RelatedDisplay() {
  return (
    <div className="grid gap-20 absolute top-16 right-20 z-10 pointer-events-none select-none line-height-1">
      <div className="grid gap-0 place-items-center">
        <NextDropDisplay />
        <ScoreDisplay />
      </div>
      <div className="hidden md:block">
        <BlockEvolution />
      </div>
    </div>
  );
}
